import request from "./request";
/**
 * 删除评论
 * @param pageId 专页id
 * @param commentId 评论id
 */
export default async function deleteComments(data) {
  return await request.post("/spin/dataSend/deleteComments", data);
}
